import React from 'react';

import { useTrackingStatus } from '../../features/tracking/components/functional/useTrackingStatus';
import { ProgressBarStepModel } from './model';
import { ProgressStepLayout } from './ProgressStepLayout';

export interface ProgressStepComponentProps extends ProgressBarStepModel {
  onClick?: () => void;
  style?: React.CSSProperties;
  inProgress?: boolean;
  className?: string;
}

export const ProgressStepComponent: React.FC<ProgressStepComponentProps> = (props) => {
  const { isComplete } = useTrackingStatus(props.id);

  const isCompleted = !props.disabled && isComplete;
  const isClickable = props.onClick && !props.disabled && !props.selected && isCompleted;

  return <ProgressStepLayout {...props} isClickable={isClickable} isCompleted={isCompleted} />;
};
